/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiPerson } from './InternalApiPerson';
import {
    InternalApiPersonFromJSON,
    InternalApiPersonFromJSONTyped,
    InternalApiPersonToJSON,
    InternalApiPersonToJSONTyped,
} from './InternalApiPerson';

/**
 * 
 * @export
 * @interface InternalApiPersonsPage
 */
export interface InternalApiPersonsPage {
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiPersonsPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiPerson>}
     * @memberof InternalApiPersonsPage
     */
    content: Array<InternalApiPerson>;
}

/**
 * Check if a given object implements the InternalApiPersonsPage interface.
 */
export function instanceOfInternalApiPersonsPage(value: object): value is InternalApiPersonsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalApiPersonsPageFromJSON(json: any): InternalApiPersonsPage {
    return InternalApiPersonsPageFromJSONTyped(json, false);
}

export function InternalApiPersonsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiPersonsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiPersonFromJSON)),
    };
}

export function InternalApiPersonsPageToJSON(json: any): InternalApiPersonsPage {
    return InternalApiPersonsPageToJSONTyped(json, false);
}

export function InternalApiPersonsPageToJSONTyped(value?: InternalApiPersonsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiPersonToJSON)),
    };
}

